const COUNTRIES = [
  { flag: "🇦🇪", name: "UAE", cities: "Dubai · Abu Dhabi · Sharjah" },
  { flag: "🇸🇦", name: "Saudi Arabia", cities: "Riyadh · Jeddah · Khobar" },
  { flag: "🇶🇦", name: "Qatar", cities: "Doha" },
  { flag: "🇰🇼", name: "Kuwait", cities: "Kuwait City" },
  { flag: "🇧🇭", name: "Bahrain", cities: "Manama" },
  { flag: "🇴🇲", name: "Oman", cities: "Muscat · Salalah" },
  { flag: "🇪🇬", name: "Egypt", cities: "Cairo · Alexandria" },
  { flag: "🇯🇴", name: "Jordan", cities: "Amman" },
  { flag: "🇱🇧", name: "Lebanon", cities: "Beirut" },
  { flag: "🇲🇦", name: "Morocco", cities: "Casablanca · Marrakech" },
  { flag: "🇹🇷", name: "Türkiye", cities: "Istanbul · Antalya" },
  { flag: "🇵🇰", name: "Pakistan", cities: "Karachi · Lahore · Islamabad" },
];

export default function Coverage() {
  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="relative py-28 sm:py-36 bg-[#0A0A0A] text-white grain overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Left — headline */}
          <div className="lg:col-span-6">
            <p className="text-xs uppercase tracking-[0.24em] text-[#9CC07B] font-semibold">
              Coverage
            </p>
            <h2
              data-testid="coverage-headline"
              className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.02] mt-6 text-white"
            >
              Lychee operates across the{" "}
              <span className="text-white/95">MENA region</span> and{" "}
              <span className="text-white/95">South Asia.</span>
            </h2>
            <p className="mt-10 max-w-md text-base leading-relaxed text-[#B1B7AB]">
              A vetted roster of on-ground creators in every market we cover
              &mdash; booked, briefed, and dispatched locally.
            </p>
          </div>

          {/* Right — country grid */}
          <div className="lg:col-span-6 lg:pt-4">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-10">
              {COUNTRIES.map((c) => (
                <div
                  key={c.name}
                  data-testid={`country-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className="flex flex-col"
                >
                  <div className="flex items-center gap-2.5">
                    <span
                      className="text-2xl leading-none select-none"
                      aria-hidden
                    >
                      {c.flag}
                    </span>
                    <span className="text-base font-semibold text-white">
                      {c.name}
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-[#B1B7AB]/80 leading-snug">
                    {c.cities}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
